import { ANGLE_AXES, ANGLE_MEASUREMENT_AXIS_PARENT_MAP, ANGLE_MEASUREMENTS } from './angleMappings';
import {
    DISPLACEMENT_AXES,
    DISPLACEMENT_MEASUREMENTS,
    DISPLACEMENT_MEASUREMENTS_PARENT_MAP,
} from './displacementMappings';
import { DISTANCE_AXES, DISTANCE_MEASUREMENTS, DISTANCE_MEASUREMENTS_PARENT_MAP } from './distanceMappings';
import { JOINT_ANGLE_AXES, JOINT_ANGLE_MEASUREMENTS, JOINT_ANGLE_MEASUREMENTS_PARENT_MAP } from './jointAngleMappings';
import { VisualizationAxis, VisualizationMeasurement } from './types';

export * from './angleMappings';
export * from './displacementMappings';
export * from './jointAngleMappings';
export * from './types';
export * from './swingPlanes';
export * from './paths';
export * from './distanceMappings';

export const VISUALIZATION_MEASUREMENTS: Record<string, VisualizationMeasurement> = {
    ...DISPLACEMENT_MEASUREMENTS,
    ...ANGLE_MEASUREMENTS,
    ...JOINT_ANGLE_MEASUREMENTS,
    ...DISTANCE_MEASUREMENTS,
};
export const VISUALIZATION_AXES: Record<string, VisualizationAxis> = {
    ...DISPLACEMENT_AXES,
    ...ANGLE_AXES,
    ...JOINT_ANGLE_AXES,
    ...DISTANCE_AXES,
};
export const VISUALIZATION_AXES_PARENT_MAP = {
    ...DISPLACEMENT_MEASUREMENTS_PARENT_MAP,
    ...ANGLE_MEASUREMENT_AXIS_PARENT_MAP,
    ...JOINT_ANGLE_MEASUREMENTS_PARENT_MAP,
    ...DISTANCE_MEASUREMENTS_PARENT_MAP,
};

export type VisualizationMeasurementName = keyof typeof VISUALIZATION_MEASUREMENTS;
export type VisualizationAxisId = keyof typeof VISUALIZATION_AXES;

export const VISUALIZATION_MEASUREMENT_TYPES: Record<string, 'extended' | 'connected'> = {
    head_linear_displacement: 'extended',
    upper_torso_linear_displacement: 'extended',
    left_wrist_linear_displacement: 'extended',
    right_wrist_linear_displacement: 'extended',
    left_ankle_linear_displacement: 'extended',
    right_ankle_linear_displacement: 'extended',
    left_knee_linear_displacement: 'extended',
    right_knee_linear_displacement: 'extended',
    left_elbow_linear_displacement: 'extended',
    right_elbow_linear_displacement: 'extended',
    left_shoulder_linear_displacement: 'extended',
    right_shoulder_linear_displacement: 'extended',
    left_hip_linear_displacement: 'extended',
    right_hip_linear_displacement: 'extended',
    pelvis_linear_displacement: 'extended',
    upper_torso_angular_position: 'extended',
    pelvis_angular_position: 'extended',
    head_angular_position: 'extended',
    left_knee_angle: 'connected',
    right_knee_angle: 'connected',
    left_elbow_angle: 'connected',
    right_elbow_angle: 'connected',
    left_hip_angle: 'connected',
    right_hip_angle: 'connected',
    left_ankle_angle: 'connected',
    right_ankle_angle: 'connected',
    left_forearm_angle_with_club_shaft: 'extended',
    spine_angle: 'extended',
    club_bend: 'extended',
    club_tilt: 'extended',
    shaft_direction_to_y_axis: 'extended',
    club_angle_to_shaft_plane_at_setup: 'extended',
    spine_bend: 'extended',
    spine_tilt: 'extended',
    x_factor: 'extended',
};
